<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tOkgpR/tc-custom/9781614234289.jpg?1695291860520" alt="This image is the cover for the book Memphis Murder & Mayhem"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memphis Murder & Mayhem
      </h1>
      <p class="bookDescription body article font2">
        <b>A journey through Memphis’ troubled past: the shocking crimes and the brutal killings that led to it being dubbed the “Murder Capital of the World.” </b><br/>  <br/> With its alluring hospitality, legendary cuisine and transcendent music, Memphis is truly a quintessential Southern city. But lurking behind the barbeque and blue suede shoes is a dark history checkered with violence and disarray. Revisit the mass murder of 1866 that took more than fifty lives, the infamous Alice Mitchell case of the 1890s and a string of unthinkable twentieth-century sins. Author and lifelong Memphian Teresa Simpson explores some of the River City’s most menacing crimes and notorious characters in this riveting ride back through the centuries.<br/>  <br/> Includes photos!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Teresa R. Simpson
      </h2>
      
      <p class="authorDescription body article">Teresa R. Simpson was born and raised in Memphis, Tennessee, where she lives with her husband and children. As a freelance writer, she has written numerous articles on her hometown for About.com, as well as articles and essays on a variety of subjects for other print and online publications. Teresa is also the author of The Everything Baby Sign Language Book, published by Adams Media in 2008.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b9c3e32